module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/AlignLeft-5d745e9101a0ca071e696842103a08ac.svg";